<p class="alert alert-info" *ngIf="labels.length <= 0">No labels exist for this question yet.</p>
<table class="table table-striped" *ngIf="labels.length">
    <thead class="secondary-color text-white">
        <tr>
            <th>Label</th>
            <th>Actions</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let label of labels; let first = first; let last=last;">
            <td>
                <input class="form-control" type="text" [(ngModel)]="label.label" />
            </td>
            <td>
                <button (click)="shiftUpLabel(label)" [disabled]="first" type="button" class="btn btn-primary btn-sm" aria-label="Up">
                    <span class="fa fa-arrow-up" aria-hidden="true"></span>
                </button>
                <button (click)="shiftDownLabel(label)" [disabled]="last" type="button" class="btn btn-primary btn-sm" aria-label="Down">
                    <span class="fa fa-arrow-down" aria-hidden="true"></span>
                </button>
                <button (click)="deleteLabel(label)" type="button" class="btn btn-secondary btn-sm" aria-label="Delete">
                    <span class="fa fa-trash" aria-hidden="true"></span>
                </button>
            </td>
        </tr>
    </tbody>
</table>
<div class="row">
        <input type="text" [(ngModel)]="newLabel.label" class="form-control col" placeholder="Label Name..." />
        <div class="col">
            <input type="button" class="btn btn-primary" value="Add" (click)="addLabel()" />
        </div>
</div>




// WEBPACK FOOTER //
// ./src/app/admin/question-labels-edit/question-labels-edit.component.html